/** Playback ID faktycznie używany w HeroContainer na stronie głównej. */
export const HOMEPAGE_MUX_PLAYBACK_ID = "cYA3DkwPfDGUf41Y7VnnFz34LFY75gIR02TMy02TSonpk";

export function extractPlaybackIdFromHls(url?: string | null): string | null {
    if (!url) return null;
    const match = url.match(/https?:\/\/stream\.mux\.com\/([^./]+)\.m3u8/i);
    return match?.[1] ?? null;
}

export function resolveMuxPlaybackId(input?: {
    muxPlaybackId?: string | null;
    hlsUrl?: string | null;
} | null): string | null {
    return (
        input?.muxPlaybackId?.trim() ||
        extractPlaybackIdFromHls(input?.hlsUrl?.trim()) ||
        null
    );
}

type MuxPosterOptions = {
    time?: number;
    width?: number;
    quality?: number;
    format?: "webp" | "jpg";
};

export function buildMuxPosterUrl(playbackId: string, opts?: MuxPosterOptions): string {
    const time = opts?.time ?? 0;
    const width = opts?.width ?? 1200;
    const quality = opts?.quality ?? 70;
    const format = opts?.format ?? "webp";

    return `https://image.mux.com/${playbackId}/thumbnail.${format}?time=${encodeURIComponent(String(time))}&width=${width}&quality=${quality}&fit_mode=preserve`;
}

export function shouldAvoidMuxAutoplay(): boolean {
    if (typeof navigator === "undefined") return false;
    const conn =
        // @ts-expect-error legacy vendor prefixes
        navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!conn) return false;
    return conn.saveData === true || conn.effectiveType === "slow-2g" || conn.effectiveType === "2g";
}

export function buildMuxStreamUrl(playbackId: string): string {
    const params = new URLSearchParams({
        min_resolution: "720p",
        rendition_order: "desc",
    });

    return `https://stream.mux.com/${playbackId}.m3u8?${params.toString()}`;
}
